import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit, AfterViewInit {
  @Input() privVisible: boolean;

  constructor(private title: Title,private meta: Meta) { }

  ngOnInit() {
    this.title.setTitle('Privacy Policy | Honest Gorilla');
    this.meta.updateTag({name: 'keywords', content: 'honest gorilla,privacy policy,legal,privacy,personal information'});
    this.meta.updateTag({name: 'description', content: 'The Honest Gorilla Privacy Policy is in place to help protect you. Keeping your information safe is our priority.'});
    this.meta.updateTag({name: 'author', content: 'HonestGorilla'});
    this.meta.updateTag({name: 'robots', content: 'index, follow'});
  }
  ngAfterViewInit(): void {
    $('.navbar-toggler').click(function () {
      $('.navbar').toggleClass('parent');
    });
  }
  mailMe (mail) // <--- element on which you need to apply click
  {
      mail = document.createElement("a");
      mail.href = "mailto:hello@honestgorilla.com?subject=Question&body=Hi";
      mail.click();
  }
}
